<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<!-- The a11y warning is a false alarm in this case RevToolTip ensures that ariaDescribedBy 
and other properties are used to link the non-interactive element with the contents of the tooltip -->

<!--  Pill is a component that should be typicallly used for displaying static informational content such as icons or text. 
  It is typically accompained by a tooltip to provide additional context but this is not always the case.
  To ensure that children of the Pill are sized or styled appropriately (there are three size variants),
  the default slot has access to helper classes relating to sizing.
  For interactive content, the Pill should be wrapped by a Button or similar element. -->

<template>
  <template v-if="!props.tooltipContent">
    <span
      class="bg-static-default-mid text-static-default-hi flex items-center justify-between gap-4 rounded-[1.25rem] px-8 py-4"
      :class="props.customClass"
    >
      <slot
        :flagSize="pillFlagSize"
        :iconSize="pillIconSize"
        :textSize="pillTextSizeClass"
      ></slot>
    </span>
  </template>
  <RevTooltip v-else class="z-[1]">
    <template #trigger="{ show, hide, ...triggerProps }">
      <span
        v-bind="triggerProps"
        class="bg-static-default-mid text-static-default-hi flex items-center justify-between gap-4 rounded-[1.25rem] px-8 py-4"
        :class="props.customClass"
        @focusin="show"
        @focusout="hide"
        @mouseleave="hide"
        @mouseover="show"
      >
        <slot
          :flagSize="pillFlagSize"
          :iconSize="pillIconSize"
          :textSize="pillTextSizeClass"
        ></slot>
      </span>
    </template>
    <p v-if="props.tooltipContent">{{ tooltipContent }}</p>
  </RevTooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { FlagSize } from '@backmarket/nuxt-layer-base/components/Flag/Flag.types.ts'
import type { IconProps } from '@ds/components/Icon'
import { RevTooltip } from '@ds/components/Tooltip'
import type { ClassAttr } from '@ds/types/ClassAttr'

const props = withDefaults(
  defineProps<{
    size?: 'small' | 'medium' | 'large'
    tooltipContent?: string
    customClass?: ClassAttr
  }>(),
  {
    size: 'small',
    tooltipContent: undefined,
    customClass: undefined,
  },
)

const pillTextSizeClass = computed(() => {
  const textSizeMap = {
    small: 'caption',
    medium: 'body-2',
    large: 'body-1',
  }

  return textSizeMap[props.size]
})

const pillIconSize = computed(() => {
  const iconSizeMap: Record<'small' | 'medium' | 'large', IconProps['size']> = {
    small: '16',
    medium: '20',
    large: '24',
  }

  return iconSizeMap[props.size]
})

const pillFlagSize = computed(() => {
  const flagSizeMap: Record<'small' | 'medium' | 'large', FlagSize> = {
    small: 's',
    medium: 'm',
    large: 'l',
  }

  return flagSizeMap[props.size]
})
</script>
